import React, { memo } from 'react'
import Box from 'transfix-ui/core/Box'
import Grid from 'transfix-ui/core/Grid'
import Skeleton from 'transfix-ui/core/Skeleton'

export interface ICoverageFormBodySkeletonProps {}

const CoverageFormBodySkeleton = memo<ICoverageFormBodySkeletonProps>(() => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Skeleton variant='text' width={142} height={22} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant='rectangular' height={40} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant='text' width={90} height={13} />
            <Skeleton variant='rectangular' height={40} />
            <Box mt={1}>
              <Skeleton variant='rectangular' width={75} height={18} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Skeleton variant='text' width={95} height={13} />
                <Skeleton variant='rectangular' height={40} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant='text' width={54} height={13} />
                <Skeleton variant='rectangular' height={40} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant='text' width={25} height={13} />
            <Skeleton variant='rectangular' height={40} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant='rectangular' height={200} />
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Skeleton variant='text' width={115} height={22} />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item>
                <Skeleton variant='circular' width={16} height={16} />
              </Grid>
              <Grid item>
                <Skeleton variant='text' width={122} />
                <Skeleton variant='text' width={331} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item>
                <Skeleton variant='circular' width={16} height={16} />
              </Grid>
              <Grid item>
                <Skeleton variant='text' width={122} />
                <Skeleton variant='text' width={245} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rectangular' height={55} />
      </Grid>
    </Grid>
  )
})

export default CoverageFormBodySkeleton
